import { render, staticRenderFns } from "./purchase-detail.vue?vue&type=template&id=15329de0&scoped=true&"
import script from "./purchase-detail.vue?vue&type=script&lang=js&"
export * from "./purchase-detail.vue?vue&type=script&lang=js&"
import style0 from "./purchase-detail.vue?vue&type=style&index=0&id=15329de0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.9.8@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "15329de0",
  null
  
)

export default component.exports